import { useState } from 'react'
import { useAuth } from 'app/provider/auth'
import { useSignUp } from './commands'
import { useRouter } from 'solito/router'
import { SignUpFormValues } from './components'
import { SignUpScreen } from './sign-up-screen'
import { useLogIn } from '../log-in-screen/commands'
import { LogInOutputToAuthUserConverter } from '../log-in-screen/converters'

export interface SignUpScreenContainerProps {
  referralCode?: string
}

export const SignUpScreenContainer = (props: SignUpScreenContainerProps) => {
  const [mutateSignUp, { loading: signingUp, error: signUpError }] = useSignUp()
  const [mutateLogIn, { loading: loggingIn, error: logInError }] = useLogIn()
  const [signUpDisabled, setSignUpDisabled] = useState(false)
  const { logIn } = useAuth()
  const { replace } = useRouter()

  const handleSubmit = async (values: SignUpFormValues) => {
    try {
      setSignUpDisabled(true)

      const signUpResponse = await mutateSignUp({
        variables: {
          email: values.email,
          password: values.password,
          firstName: values.firstName,
          lastName: values.lastName,
          referralCode: props.referralCode,
        },
      })

      // Hopefully we don't get here, because the request should have thrown an error
      // and the mutation state will have captured the error
      if (!signUpResponse.data?.signUpUser.success) {
        return
      }

      // TODO: If signing up succeeded but login failed then the user will see "Email already used"
      const loginResponse = await mutateLogIn({
        variables: {
          email: values.email,
          password: values.password,
        },
      })

      const user = LogInOutputToAuthUserConverter.convert(loginResponse.data!)

      if (!user?.token) {
        return
      }

      await logIn({
        ...user,
      })

      replace('/onboarding/opt-in')

      // Sleep for a bit to give the the frontend the chance to navigate to the next screen
      await new Promise((resolve) => setTimeout(resolve, 4000))
    } catch (error) {
      console.log(error)
    } finally {
      setSignUpDisabled(false)
    }
  }

  return (
    <SignUpScreen
      loading={signingUp || loggingIn || signUpDisabled}
      error={signUpError?.message || logInError?.message}
      onSubmit={handleSubmit}
    />
  )
}
